import { Alert, Button, LinearProgress } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { api, ApiError } from '../api/client';
import { PendingRequests } from '../api/pending-requests';
import type { FakesMatrixRow, FakesResult } from '../api/types';
import { fakeError } from './fakes-presentation';
import { SerpHeatmap } from './SerpHeatmap';

/** Mount with a snapshot/query key: old responses cannot replace a new selection. */
export function SerpMapQueryDetail({
  workspaceId,
  queryId,
  input,
  onRefresh,
  onSelect,
}: {
  workspaceId: string;
  queryId: string;
  input: Parameters<typeof api.fakesMapQueryDetail>[2];
  onRefresh(): void;
  onSelect(result: FakesResult, row: FakesMatrixRow): void;
}) {
  const [row, setRow] = useState<FakesMatrixRow | null>(null);
  const [error, setError] = useState<{ message: string; changed: boolean } | null>(null);
  const [attempt, setAttempt] = useState(0);
  const pending = useRef(new PendingRequests());
  const { top, runId, changes, groupId, revision, builtAt } = input;
  useEffect(() => {
    let live = true;
    setError(null);
    setRow(null);
    pending.current
      .run(
        JSON.stringify([workspaceId, queryId, top, runId, changes, groupId, revision, builtAt]),
        () =>
          api.fakesMapQueryDetail(workspaceId, queryId, {
            top,
            runId,
            changes,
            groupId,
            revision,
            builtAt,
          }),
      )
      .then((value) => {
        if (live) setRow(value);
      })
      .catch((value) => {
        if (live)
          setError({
            message: fakeError(value),
            changed: value instanceof ApiError && value.status === 409,
          });
      });
    return () => {
      live = false;
    };
  }, [workspaceId, queryId, top, runId, changes, groupId, revision, builtAt, attempt]);
  if (error)
    return (
      <Alert
        severity="error"
        action={
          <Button onClick={error.changed ? onRefresh : () => setAttempt((n) => n + 1)}>
            {error.changed ? 'Обновить карту' : 'Повторить загрузку'}
          </Button>
        }
      >
        {error.message}
      </Alert>
    );
  if (!row) return <LinearProgress aria-label="Загрузка выдачи запроса" />;
  return (
    <SerpHeatmap
      rows={[row]}
      top={top}
      total={1}
      page={1}
      groupName={row.groupName}
      disabled={false}
      onSelect={onSelect}
    />
  );
}
